export default __webpack_public_path__ + "82687a0d6cea8719c696c3b7baed5e19.png";